<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Xt2BxP/media/FC-9789948778011.jpg?1708094060567" alt="This image is the cover for the book Mindful Futurism: Paving the Way for Future Generations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mindful Futurism: Paving the Way for Future Generations
      </h1>
      <p class="bookDescription body article font2">
        <p>What is the common root of the most significant crises facing humanity today? And what is a simple, universal tool both individuals and businesses can apply to create the most leverage for positive change? These are the two urgent questions at the heart of this book. Spurred by a turbulent entry into fatherhood, the author walks readers through his rude awakening to the state of the modern world, into the deeper realization of the flawed mindset threatening our future – and the universal system he devised to remedy it. Relevant to both citizens and CEO’s, Mindful Futurism offers a critical tool at a time we need it most: a compact and memorable framework to guide our decision-making processes; designed to ensure the security and wellbeing of humanity for centuries to come.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rakan Brahedni
      </h2>
      
      <p class="authorDescription body article">Rakan Brahedni is a technologist, futurist, certified health coach, and father-of-two on a mission to inspire others to live more mindful and meaningful lives with the hope of building a better world for future generations. He and his family reside in Dubai where he is currently working on his second book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?de107a8c